<template>
  <!-- <div class="border border-gray-300 dark:border-gray-800 bg-white rounded flex items-center h-10">
    <input
      type="number"
      ref="hoursInput"
      min="0"
      placeholder="HH"
      v-model="time.hours"
      @change="changeTime"
      @click="select('hours')"
      class="w-1/3 text-center pl-3 pr-0 rounded border-none py-0 focus:ring-0 focus:outline-none"
    >
    <p>:</p>
    <input
      type="number"
      ref="minutesInput"
      min="0"
      placeholder="MM"
      max="60"
      v-model="time.minutes"
      @change="changeTime"
      @click="select('minutes')"
      class="w-1/3 text-center pl-3 pr-0 rounded border-none py-0 focus:ring-0 focus:outline-none"
    >
    <p>:</p>
    <input
      type="number"
      ref="secondsInput"
      min="0"
      placeholder="SS"
      max="60"
      v-model="time.seconds"
      @change="changeTime"
      @click="select('seconds')"
      class="w-1/3 text-center pl-3 pr-0 rounded border-none py-0 focus:ring-0 focus:outline-none" -->
  <div class="border border-gray-300 dark:border-gray-800 bg-white dark:bg-input-dark rounded flex items-center h-10">
    <input
      v-model="time.hours"
      type="number"
      min="0"
      placeholder="HH"
      @change="changeTime"
      @click="select('hours')"
      class="w-1/3 text-center pl-3 pr-0 rounded border-none py-0 focus:ring-0 focus:outline-none"
      ref="hoursInput"
    >
    <p class="font-extrabold">
      :
    </p>
    <input
      v-model="time.minutes"
      type="number"
      min="0"
      placeholder="MM"
      max="60"
      @change="changeTime"
      @click="select('minutes')"
      class="w-1/3 text-center pl-3 pr-0 rounded border-none py-0 focus:ring-0 focus:outline-none"
      ref="minutesInput"
    >
    <p class="font-extrabold">
      :
    </p>
    <input
      v-model="time.seconds"
      type="number"
      min="0"
      placeholder="SS"
      max="60"
      @change="changeTime"
      @click="select('seconds')"
      class="w-1/3 text-center pl-3 pr-0 rounded border-none py-0 focus:ring-0 focus:outline-none"
      ref="secondsInput"
    >
  </div>
</template>

<script>
export default {
  name: "TotalTimeSelector",
  props: {
    hours: {
      type: String,
      required: true
    },
    minutes: {
      type: String,
      required: true
    },
    seconds: {
      type: String,
      required: true
    }
  },
  emits: ["changeTime"],
  data() {
    return {
      time: {
        hours: null,
        minutes: null,
        seconds: null
      }
    }
  },
  watch: {
    hours(val, oldVal) {
      if (val !== oldVal) this.displayTime()
    },
    minutes(val, oldVal) {
      if (val !== oldVal) this.displayTime()
    },
    seconds(val, oldVal) {
      if (val !== oldVal) this.displayTime()
    },
  },
  mounted() {
    this.displayTime()
  },
  methods: {
    changeTime() {
      for (let val in this.time) if (!this.time[val]) this.time[val] = 0
      let totalTime = parseInt(this.time.hours) * 3600 + parseInt(this.time.minutes) * 60 + parseInt(this.time.seconds)
      this.$emit("changeTime", totalTime)
      this.displayTime()
    },
    displayTime() {
      this.time.hours = this.hours
      this.time.minutes = this.minutes
      this.time.seconds = this.seconds 
    },
    select(input) {
      this.$refs[`${input}Input`].select()
    }
  }
}
</script>
